/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import logo from '../Recursos/logo_claro.svg'
import {DATOS, POLITICAS, SECCIONES} from "../Constantes";
import {useIrRuta} from "../Utilidades/useIrRuta";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../App";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politica from "./Dialogos/Dialogo_Politicas";

const Footer = () => {
    const cData = useContext(contexApp);
    const {ir} = useIrRuta()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politica})
    const [politicas, setPoliticas] = useState([])

    useEffect(() => {

        if (cData.politicas.length > 0) {
            setPoliticas(cData.politicas)
        }

    },[cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#000'}}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 8, color: '#fff'}}
                spacing={6}
            >

                <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={250} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                            <Typography>
                                Más que una plataforma, somos la comunidad que camina a tu lado protegiendo tu esfuerzo
                            </Typography>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, fontWeight: 800}}>Links Rapidos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                {SECCIONES.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                        <Typography
                                            onClick={() => ir(it)}
                                        sx={{
                                            cursor: 'pointer',
                                        }}
                                        >{it}</Typography>
                                    </Grid>
                                ))}

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, fontWeight: 800}}>Politicas</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                {politicas.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                        <Typography
                                            onClick={() => abrir(it)}
                                        sx={{cursor: 'pointer', }}
                                        >{it.titulo}</Typography>
                                    </Grid>
                                ))}

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 18, fontWeight: 800}}>Contactos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                {DATOS.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                        <Typography
                                        >{it.nombre}</Typography>
                                    </Grid>
                                ))}

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}}
                      sx={{justifyContent: 'center', borderTop: 1, borderColor: '#ffffff80', pt: 4}}>

                    <Typography>© Esperanza Hispana 2025 - 2026</Typography>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer